import { computed } from 'vue'
import { useStore } from 'vuex'

const edoCuentaStore = () => {    
    const store = useStore()
    const setEdoCuenta = async( estadoCuenta  ) => {
        const resp = await store.dispatch('setEdoCuenta', estadoCuenta ).catch(error => {
            console.log(error)
            throw { ok: false, message: "VUEX problem" }
        }) 
        return resp
    }

    const clearEdoCuenta = async(   ) => {
        const resp = await store.dispatch('clearEdoCuenta' ).catch(error => {
            console.log("Error --->" )
            console.log(error)
            throw { ok: false, message: "VUEX problem" }
        }) 
        return resp
    }

    const getEdoCuentaFromStore = async() => {
        const edoCuentaStore= store.getters.edoCuenta;
        return edoCuentaStore
    }

    return {
        setEdoCuenta,clearEdoCuenta,getEdoCuentaFromStore
    }

}

export default edoCuentaStore
